import React from 'react'
import {
    makeStyles,
    CircularProgress,
    TableRow,
    TableCell,
} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
    tableRowCentered: {
        textAlign: 'center',
    },
}))

const TableContentLoadingSpinner = () => {
    const classes = useStyles()

    return (
        <TableRow>
            <TableCell className={classes.tableRowCentered} colSpan={'100%'}>
                <CircularProgress />
            </TableCell>
        </TableRow>
    )
}

export default TableContentLoadingSpinner
